// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `group-popups .member-container {
  touch-action: none;
}
@media only screen and (max-height: 550px) {
  group-popups .member-container {
    touch-action: initial;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/group-popups/group-popups.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAGI;EACI;IACI,qBAAA;EADV;AACF","sourcesContent":["group-popups {\n    .member-container {\n        touch-action: none;  // Prevent pull-to-refresh on iOS 15 when this is inside simple select\n    }\n\n    @media only screen and (max-height: 550px) {\n        .member-container {\n            touch-action: initial; // Allow scroll / no prevent pull-to-refresh on very small screen\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
